import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { Component, ViewEncapsulation, ElementRef, Inject } from '@angular/core';

@Component({
  selector: 'dialog-success-sell',
  templateUrl: './dialog-success-sell.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DialogSuccessSellComponent extends DialogFullScreenComponentContent {

  constructor(private dialogReference : MatDialogRef<DialogSuccessSellComponent>, element : ElementRef, @Inject(MAT_DIALOG_DATA) public data : any) {
      super(element);
  }

  dispose(){
    super.close(this.dialogReference, null);
  }
}